import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ChevronDownIcon from 'src/Components/Common/Svg/ChevronDownIcon';
import CheckvronUpIcon from 'src/Components/Common/Svg/ChevronUpIcon';
import './FAQs.css';
function FAQs(props) {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (index) => {

    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="faq-container">

      { props.faq?.map((content, index) => (

        <div key={index}>
          <div className="faq">
            <div className="faq-detail">
              <div
                className="faq-topic-container"
                onClick={() => toggleDescription(index)}>

                <div>
                  <span className="faq-topic">{content.topic}</span>
                </div>

                <div>
                  <span>
                    { expandedIndex === index
                      ? <CheckvronUpIcon />

                      : <ChevronDownIcon />
                    }
                  </span>
                </div>
              </div>

              { expandedIndex === index && content.description &&
                <div className="faq-description">
                  { content.description.includes('\n') 
                    ? content.description.split('\n').map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                      ))
                    : <p>{content.description}</p>
                  }
                </div>
              }

              { expandedIndex === index && content.details && (
                <ul className="faq-dot-list">
                  {content.details.map((detail, detailIndex) => (
                    <li className="faq-description" key={detailIndex}>
                      {detail}
                    </li>
                  ))
                  }
                </ul>
              )}

            </div>
          </div>

          <hr className="faq-divider" />

        </div>
      ))}
    </div>
  );
}

FAQs.propTypes = {
  faq: PropTypes.arrayOf(
    PropTypes.shape({
      topic: PropTypes.string.isRequired,
      description: PropTypes.string,
      details: PropTypes.arrayOf(
        PropTypes.shape({
          detail: PropTypes.string.isRequired,
        })
      ),
      icon: PropTypes.node,
    })
  ),
};

export default FAQs;
